module.exports = __webpack_public_path__ + "static/small icons-09-96eb7a8cb4cfd592424fc4c6a4b3bad9.png";